import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserRoleEnum } from '../enums/user-role.enum';

export const roleGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const roleIdsString = localStorage.getItem('roleIds');
  
  if (!roleIdsString) {
    router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  try {
    const roleIds: string[] = JSON.parse(roleIdsString);
    
    const hasAdminRole = roleIds.includes(UserRoleEnum.Admin);
    const hasExpertRole = roleIds.includes(UserRoleEnum.Expert);
    
    if (hasAdminRole || hasExpertRole) {
      return true;
    }
    
    router.navigate(['/']);
    return false;
    
  } catch (error) {
    console.error('Error parsing roleIds from localStorage:', error);
    router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
};
